import { ProspectsPage } from './ProspectsPage';

export function LeadsPage() {
  return <ProspectsPage variant="leads" />;
}
